import List from 'containers/InProcessOrders/List';

export default { List };
